import get from 'lodash/get';
import { SCOPE } from './index';

const selector = state => get(state, SCOPE);
export default selector;
